import { ComponentProps, ReactNode } from "react";
import styled from "styled-components";
import {
  ModalProvider as StyledReactModalProvider,
  BaseModalBackground,
} from "styled-react-modal";

type StyledReactModalProviderProps = ComponentProps<
  typeof StyledReactModalProvider
>;

const StyledBaseModalBackground = styled(BaseModalBackground)`
  box-sizing: border-box;
  padding: 40px 0;
`;

type ModalProviderProps = {
  children: ReactNode;
  backgroundComponent?: StyledReactModalProviderProps["backgroundComponent"];
};

export { BaseModalBackground };

export const ModalProvider = ({
  children,
  backgroundComponent = StyledBaseModalBackground,
}: ModalProviderProps) => {
  return (
    <StyledReactModalProvider backgroundComponent={backgroundComponent}>
      {children}
    </StyledReactModalProvider>
  );
};
